import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { ActivateDoctorComponent } from './activate-doctor/activate-doctor.component';
import { MainLayoutComponent } from '@app/shared-module/main-layout/main-layout.component';
import { SupportComponent } from '@app/extra-module/support/support.component';
import { LoginComponent } from '../shared-module/login/login.component';

const routes: Routes = [
  { path: 'doctor/activate/:doctorID', component: ActivateDoctorComponent },
  { path: 'login', component: LoginComponent, data: { title: 'Login', enableExtraHeader: false } },
  {
    path: 'extra', component: MainLayoutComponent,
    children: [
      { path: 'underconstruction', component: UnderConstructionComponent, data: { title: 'Under Construction', enableExtraHeader: false } },
      { path: '', redirectTo: 'underconstruction', pathMatch: 'full' },
      { path: 'support', component: SupportComponent, data: { title: 'Support', enableExtraHeader: false } },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExtraRoutingModule { }
